import { render, staticRenderFns } from "./EventPreviewBaseCard.vue?vue&type=template&id=17e819d4"
import script from "./EventPreviewBaseCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventPreviewBaseCard.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports